import React, { useState, useEffect } from 'react';
//import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HashRouter as Router, Route, Routes } from 'react-router-dom';

import log from "loglevel";

import { TranslationProvider } from "./context/TranslationContext";
import { ThemeProvider } from "./context/ThemeContext"; 
import { NotificationProvider } from './context/NotificationContext';
import { WebSocketProvider } from './context/WebSocketContext';
import { AuthProvider } from './context/AuthContext';
import { AppProvider } from './context/AppContext';
import PrivateRoute from './utils/PrivateRoute';

import Store from "./store/Store";
import PathSaver from "./store/PathSaver";
import Home from "./pages/Home";
import Host from "./pages/Host";
import HostPlaces from "./pages/host/Places";
import HostAttractions from "./pages/host/Attractions";
import HostDishes from "./pages/host/Dishes";
import HostRestaurants from "./pages/host/Restaurants";
import Profile from "./pages/Profile";
import WaitingList from "./pages/WaitingList";
import Login from "./pages/Login";
import BottomPanel from './components/BottomPanel';

function App() {

  useEffect(() => {
    log.setLevel("debug");
    // Przykładowe logi
    //log.debug("This is a debug message");
    //log.info("This is an info message");
    //log.warn("This is a warning message");
    //log.error("This is an error message");

    return () => {
    };
  }, []);

  //                    <Route path="/login" element={<Login />} />

  return (
    <AppProvider>
      <TranslationProvider store={Store}>
        <WebSocketProvider>
            <Router>
              <NotificationProvider>
                <AuthProvider>
                  <ThemeProvider>
                    <PathSaver /> 
                    <Routes>
                    <Route path="*" element={<WaitingList />} />
                    <Route element={<PrivateRoute />}>
                        <Route element={<BottomPanel />}>
                          <Route path="/profile" element={<Profile />} />
                          <Route path="/tasks" element={<Home />} />
                          <Route path="/host" element={<Host />} />
                          <Route path="/messages" />
                          <Route path="/alerts" />
                          <Route path="*" element={<Profile />} />
                        </Route>
                        <Route path="/host/places" element={<HostPlaces />} />
                        <Route path="/host/attractions" element={<HostAttractions />} />
                        <Route path="/host/dishes" element={<HostDishes />} />
                        <Route path="/host/restaurants" element={<HostRestaurants />} />
                      </Route>
                    </Routes>
                  </ThemeProvider>
                </AuthProvider>
              </NotificationProvider>
            </Router>
          </WebSocketProvider>
        </TranslationProvider>
      </AppProvider>
  );
}

export default App;